declare var window: any;

// Converted as hook from apps/admin_web/assets/node_modules/flowbite/src/components/tooltip.js
const Tooltip = {
  tooltipInstance: null as any,
  hideTooltipHandler: null as (() => void) | null,
  triggerEl: null as Element | null,
  default: {
    placement: "top",
    triggerType: "hover",
    onShow: () => {},
    onHide: () => {},
  },
  initTooltip(this: any) {
    const targetEl = this.el;
    const triggerEl = document.querySelector(
      `[data-tooltip-target='${this.el.id}']`,
    );
    this.triggerEl = triggerEl;
    const triggerType = triggerEl?.getAttribute("data-tooltip-trigger");
    const placement = triggerEl?.getAttribute("data-tooltip-placement");
    const onShow = targetEl.getAttribute("data-tooltip-on-show");

    this.tooltipInstance = new window.Tooltip(targetEl, triggerEl, {
      placement: placement ? placement : this.default.placement,
      triggerType: triggerType ? triggerType : this.default.triggerType,
      onShow: onShow
        ? () => window.liveSocket.execJS(targetEl, onShow)
        : this.default.onShow,
    });

    // Hide tooltip on click of the trigger to avoid lingering when the action is clicked
    if (triggerEl && this.tooltipInstance) {
      // Use pointerdown in capture phase to hide before default link handling
      this.hideTooltipHandler = () => {
        try {
          this.tooltipInstance.hide();
        } catch (_e) {}
      };

      triggerEl.addEventListener("pointerdown", this.hideTooltipHandler, {
        capture: true,
      });
      triggerEl.addEventListener("click", this.hideTooltipHandler);
      triggerEl.addEventListener("mousedown", this.hideTooltipHandler);
    }
  },
  cleanupTooltip(this: any) {
    // Remove event listeners to prevent accumulation
    if (this.triggerEl && this.hideTooltipHandler) {
      this.triggerEl.removeEventListener(
        "pointerdown",
        this.hideTooltipHandler,
        { capture: true },
      );
      this.triggerEl.removeEventListener("click", this.hideTooltipHandler);
      this.triggerEl.removeEventListener("mousedown", this.hideTooltipHandler);
    }
    // Destroy existing tooltip instance
    if (this.tooltipInstance) {
      try {
        this.tooltipInstance.destroyAndRemoveInstance();
      } catch (_e) {
        // Instance may already be destroyed
      }
    }
  },
  mounted(this: any) {
    this.initTooltip();
  },
  updated(this: any) {
    // Clean up old instance before re-initializing
    this.cleanupTooltip();
    this.initTooltip();
  },
  destroyed(this: any) {
    this.cleanupTooltip();
  },
};

export default Tooltip;
